export class Organization {
    id: number;
    name: string;
}